import { render, staticRenderFns } from "./usps-bar.vue?vue&type=template&id=51fc4d85&"
import script from "./usps-bar.vue?vue&type=script&lang=js&"
export * from "./usps-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports